import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-pre',
  standalone: true,
  imports: [CommonModule],
  template: `
    <small *ngIf="!isProd">
      <span *ngIf="label">{{ label }}</span>
      <pre>{{ obj | json }}</pre>
    </small>
  `,
  styles: [
    `
      :host {
        display: block;
        font-size: 14px;
      }
    `,
  ],
})
export class PreComponent implements OnInit {
  @Input() label?: string;
  @Input() obj: any;
  isProd = true;

  constructor() {
    this.isProd = environment.production;
  }

  ngOnInit(): void {
    if (this.isProd) {
      console.warn('Remove pre component usage from prod');
    }
  }
}
